import React, { Fragment, useEffect, useState } from "react";
import {
  Autocomplete,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { Tabs, Tab, InputAdornment } from "@mui/material";
import { Card, Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import { toast } from "react-toastify";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { isEmpty } from "lodash";
import {
  createNewProduct,
  fetchProductById,
  updateProduct,
} from "../actions/product";
import SubmitButtonForm from "../components/Admin/Reusable/Form/SubmitButtonForm";
import FormTitleMain from "../components/Admin/Reusable/FormTitleMain";
import InputField from "../components/Admin/Reusable/InputField";
// import UploadImage from "../components/Admin/Reusable/UploadImage";
import languagesItems from "../utils/languages";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import { Editor } from "ckeditor5-custom-build/build/ckeditor";

import { TabPanel, a11yProps } from "../helper/TabPanel";
import SelectStatus from "../components/Admin/Reusable/Form/SelectStatus";

import { useSelector } from "react-redux";
import {
  basicFormValidationHandler,
  formatOnlyDateDB,
  validateLocalesFields,
} from "../utils";
import { appendIfFile } from "../helper/FileCheck";
import { productActions } from "../reducers/product";
import GlobalProgressOverlay from "../components/Admin/Reusable/GlobalProgressOverlay";
import UploadImage from "../components/Admin/Reusable/UploadImage";
import MediaPickerModal from "../components/Common/Modal/MediaPickerModal";
import AmountInputField from "../components/Admin/Reusable/AmountInputField";

const PRODUCT_TYPE_CONFIG = {
  COFFEE: [
    { value: "GR_100", label: "100gr" },
    { value: "GR_250", label: "250gr" },
    { value: "KG_1", label: "1kg" },
    { value: "BOX", label: "Box" }, // dodaj u enum ProductSize na BE ako već nije
  ],
  EQUIPMENT: [{ value: "DEFAULT", label: "Default" }],
  CLOTHS: [
    { value: "S", label: "S" },
    { value: "M", label: "M" },
    { value: "L", label: "L" },
    { value: "XL", label: "XL" },
    { value: "TWO_XL", label: "2XL" },
  ],
};

const toIsoFromDateOnly = (dateOnly, endOfDay = false) => {
  if (!dateOnly) return null;

  // dateOnly je "YYYY-MM-DD"
  const [y, m, d] = dateOnly.split("-").map(Number);

  // Local date -> pa u ISO (Z)
  const dt = endOfDay
    ? new Date(y, m - 1, d, 23, 59, 59, 999)
    : new Date(y, m - 1, d, 0, 0, 0, 0);

  return dt.toISOString();
};

const parseAmountValue = (value) => {
  if (value === "" || value === null || typeof value === "undefined") {
    return null;
  }

  const amount = Number(value);
  return Number.isFinite(amount) ? amount : null;
};

const hasInvalidDiscountPriceRelation = (details = []) =>
  details.some((d) => {
    if (!d.active || !d.discount) return false;

    const regularPrice = parseAmountValue(d.price);
    const discountPrice = parseAmountValue(d.discountPrice);

    return (
      regularPrice !== null &&
      discountPrice !== null &&
      discountPrice > regularPrice
    );
  });

const ProductAdd = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams();

  const [activeLocaleTab, setActiveLocaleTab] = useState(0);
  const handleChangeLocaleTab = (e, newValue) => setActiveLocaleTab(newValue);
  const [errors, setErrors] = useState({});
  const { productDetail, loading, success, actionType } = useSelector(
    (state) => state.productReducer
  );

  const getInitialLocales = () =>
    Object.fromEntries(
      languagesItems.map((l) => [
        l.code,
        {
          id: null,
          name: "",
          description: "",
          shortDescription: "",
          language: l.code,
        },
      ])
    );

  const initialStateFiles = {
    image: null,
    // smallImage: null,
  };

  const [locales, setLocales] = useState(getInitialLocales);
  const [files, setFiles] = useState(initialStateFiles);
  const [showMediaModal, setShowMediaModal] = useState(false);

  const handleImageSelect = (media) => {
    setFiles((prev) => ({ ...prev, image: media?.file }));
    setData((prev) => ({ ...prev, imageId: media?.id }));

    setErrors((prev) => {
      const next = { ...prev };
      delete next.image;
      return next;
    });
  };

  const makeDetailRow = (size) => ({
    id: null,
    size, // enum string
    active: false, // checkbox "Aktivan"
    price: "",
    discount: false, // checkbox "Popust"
    discountPrice: "",
    discountStart: "",
    discountEnd: "",
    quantity: null,
  });

  const initialState = {
    position: "",
    code: "",
    imageId: "",
    type: "COFFEE", //COFFEE, EQUIPMENT, CLOTHS
    filtered: true,
    espresso: true,
    active: true,
    imageGallery: [],

    details: PRODUCT_TYPE_CONFIG.COFFEE.map((s) => makeDetailRow(s.value)),
  };

  //osnovi podaci
  const [data, setData] = useState(initialState);
  const [progress, setProgress] = useState(0);
  const [showLoader, setShowLoader] = useState(false);

  //breadcrumbs
  const translateForm = "productForm";
  const translateModule = "product";
  const pageType = id ? "Edit" : "Add";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const setFile = (key) => (file) =>
    setFiles((prev) => ({ ...prev, [key]: file }));

  useEffect(() => {
    if (!id) {
      // Ako `id` ne postoji, očisti stanje za novu kreaciju
      setData(initialState);
      setLocales(getInitialLocales());

      // setFiles(initialStateFiles);
    } else {
      // Ako `id` postoji, učitaj podatke za korisnika
      dispatch(fetchProductById(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (productDetail && id) {
      setData({
        ...productDetail,
        details: (productDetail.details || []).map((d) => ({
          ...d,
          discountStart: d.discountStart
            ? formatOnlyDateDB(d.discountStart)
            : "",
          discountEnd: d.discountEnd ? formatOnlyDateDB(d.discountEnd) : "",
        })),
      });

      // popuni locales iz backend-a
      const filledLocales = Object.fromEntries(
        languagesItems.map((l) => {
          const found = productDetail.locales?.find(
            (loc) =>
              loc.language === l.code || loc.language === l.label.toUpperCase()
          );
          return [
            l.code,
            {
              id: found?.id || null,
              name: found?.name || "",
              description: found?.description || "",
              shortDescription: found?.shortDescription || "",
              language: l.code,
            },
          ];
        })
      );

      setLocales(filledLocales);
    }
  }, [productDetail, id, dispatch]);

  useEffect(() => {
    let interval;
    let timeout;

    if (loading) {
      setShowLoader(true);
      setProgress(0);

      interval = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 100) {
            clearInterval(interval);
            return 100;
          }
          return prev + 5;
        });
      }, 100);
    } else if (!loading && showLoader) {
      setProgress(100);
      timeout = setTimeout(() => {
        setShowLoader(false);
        setProgress(0);
      }, 2000);
    }

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [loading]);

  useEffect(() => {
    if (success) {
      const timeout = setTimeout(() => {
        navigate("/product-list");

        if (actionType === "create") {
          toast.success("Uspešno ste kreirali novi proizvod", {
            theme: "colored",
          });
        } else if (actionType === "update") {
          toast.success("Uspešno ste izmenili proizvod", { theme: "colored" });
        }

        dispatch(productActions.clearError());
      }, 2000);

      return () => clearTimeout(timeout);
    } else {
      dispatch(productActions.clearError());
    }
  }, [success]);

  const userValidationHandler = () => {
    let errorsObject = {};

    // univerzalno obavezna polja
    errorsObject = {
      ...errorsObject,
      ...basicFormValidationHandler({
        code: data?.code,
      }),
    };

    // ✅ Slika obavezna
    const hasImage = !!data?.imageId || !!files?.image || !!data?.imageFile;

    if (!hasImage) {
      errorsObject.image = "Slika je obavezna";
    }

    const localeErrors = validateLocalesFields(locales, [
      "name",
      "description",
      "shortDescription",
    ]);
    if (Object.keys(localeErrors).length > 0) {
      errorsObject.locales = localeErrors;
    }

    // ✅ NOVO: validacija popusta po detalju
    const discountErrors = validateDiscountDetails(data.details || []);
    if (Object.keys(discountErrors).length > 0) {
      errorsObject.details = discountErrors;
    }

    if (hasInvalidDiscountPriceRelation(data.details || [])) {
      errorsObject.discountPriceRelation =
        "Akcijska cena ne može biti veća od regularne.";
    }

    //DETAILS PROVERA
    const activeDetailsCount = (data.details || []).filter(
      (d) => d.active
    ).length;

    if (activeDetailsCount === 0) {
      errorsObject.detailsGeneral = "Morate izabrati bar jednu veličinu.";
    }

    setErrors(errorsObject);

    if (!isEmpty(errorsObject)) {
      toast.error(
        errorsObject.discountPriceRelation ||
          "Morate popuniti sva obavezna polja!",
        {
          theme: "colored",
        }
      );
    }

    return !isEmpty(errorsObject);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (userValidationHandler()) {
      return;
    }

    const formData = new FormData();

    // pretvaranje locales objekta u niz za backend
    const localesArray = Object.entries(locales).map(([code, v]) => ({
      ...v,
      // ako postoji id, prosledi; ako ne, backend može generisati
      id: v.id || undefined,
    }));

    const dataForm = {
      ...data,
      imageGallery: (data.imageGallery || []).map((x) => x.id),
      locales: localesArray,
      details: (data.details || [])
        .filter((d) => d.active || (id && d.id))
        .map((d) => ({
          ...d,
          discountStart:
            d.discount && d.discountStart
              ? toIsoFromDateOnly(d.discountStart, false)
              : null,
          discountEnd:
            d.discount && d.discountEnd
              ? toIsoFromDateOnly(d.discountEnd, true)
              : null,
        })),
    };

    if (id) {
      dataForm.id = id;
    }
    console.log(dataForm, "dataForm");
    if (id) {
      dispatch(updateProduct(dataForm, navigate, id));
    } else {
      dispatch(createNewProduct(dataForm, navigate));
    }
  };

  const updateLocale = (code, field, value) => {
    setLocales((prev) => ({
      ...prev,
      [code]: { ...prev[code], [field]: value },
    }));
  };

  const handleInputChange = (eOrName, maybeValue) => {
    if (typeof eOrName === "string") {
      const name = eOrName;
      const value = maybeValue;
      setData((prev) => ({ ...prev, [name]: value }));
      return;
    }

    const e = eOrName;
    const { name, type, value, checked } = e.target;

    setData((prev) => {
      // default ažuriranje
      let next = { ...prev, [name]: type === "checkbox" ? checked : value };

      // pravila za međusobno isključive checkboxe

      return next;
    });
  };

  //---------- NOVO DETALJI PROIZVODA -------------//
  useEffect(() => {
    setData((prev) => {
      const sizes = PRODUCT_TYPE_CONFIG[prev.type] || [];
      const prevDetails = prev.details || [];

      const nextDetails = sizes.map(({ value }) => {
        const existing = prevDetails.find((d) => d.size === value);
        return existing ? existing : makeDetailRow(value);
      });

      // opciono: ako je EQUIPMENT, možeš odmah aktivirati DEFAULT
      if (prev.type === "EQUIPMENT") {
        return {
          ...prev,
          details: nextDetails.map((d) =>
            d.size === "DEFAULT" ? { ...d, active: true } : d
          ),
        };
      }

      return { ...prev, details: nextDetails };
    });
  }, [data.type]); // ok je, jer setData koristi prev

  const updateDetail = (size, field, value) => {
    setData((prev) => ({
      ...prev,
      details: (prev.details || []).map((d) =>
        d.size === size ? { ...d, [field]: value } : d
      ),
    }));

    if (field === "active" && value === true) {
      setErrors((prev) => {
        const next = { ...prev };
        delete next.detailsGeneral;
        return next;
      });
    }
  };
  //---------- NOVO DETALJI PROIZVODA -------------//

  const validateDiscountDetails = (details = []) => {
    const detailErrors = {};

    details.forEach((d) => {
      if (!d.active) return;

      if (d.discount) {
        const e = {};

        if (!d.discountPrice) e.discountPrice = "Obavezno polje";
        if (!d.discountStart) e.discountStart = "Obavezno polje";
        if (!d.discountEnd) e.discountEnd = "Obavezno polje";

        if (
          d.discountStart &&
          d.discountEnd &&
          d.discountStart >= d.discountEnd
        ) {
          e.discountEnd = "Datum 'od' mora biti pre datuma 'do'";
        }

        if (Object.keys(e).length) {
          // ključ po size-u da znaš tačno gde je greška
          detailErrors[d.size] = e;
        }
      }
    });

    return detailErrors;
  };

  const handleGallerySelect = (mediaItems) => {
    const arr = Array.isArray(mediaItems) ? mediaItems : [mediaItems];

    setData((prev) => {
      const current = prev.imageGallery || [];

      const existingIds = new Set(current.map((x) => x.id));
      const toAdd = arr
        .filter((m) => m?.id && !existingIds.has(m.id))
        .map((m) => ({ id: m.id, file: m.file, name: m.name }));

      // opciono: izbaci glavnu sliku iz galerije
      const filteredToAdd = prev.imageId
        ? toAdd.filter((x) => x.id !== prev.imageId)
        : toAdd;

      return { ...prev, imageGallery: [...current, ...filteredToAdd] };
    });
  };

  const removeFromGallery = (idToRemove) => {
    setData((prev) => ({
      ...prev,
      imageGallery: (prev.imageGallery || []).filter(
        (x) => x.id !== idToRemove
      ),
    }));
  };

  const [showGalleryModal, setShowGalleryModal] = useState(false);

  return (
    <Fragment>
      <Breadcrumb
        breadcrumbItems={breadcrumbItems}
        type={`${translateModule}${pageType}`}
        id={id}
        pageType={pageType}
      />
      {showLoader && <GlobalProgressOverlay progress={progress} />}
      <Container className="product-container">
        <Row>
          <Col lg={12}>
            <form onSubmit={handleSubmit} noValidate>
              <Row>
                <Col lg={12}>
                  <div className="text-end mb-2">
                    <SubmitButtonForm id={id} />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={8}>
                  <Row>
                    <Col lg={12}>
                      <Card>
                        <Card.Header>
                          <FormTitleMain />
                        </Card.Header>
                        <Card.Body>
                          <div className="blog-holder-admin-left-side-text">
                            <Row>
                              <Col lg={4} md={12} xs={12} className="mb-4">
                                <InputField
                                  label="Šifra proizvoda"
                                  name="code"
                                  value={data.code}
                                  onChange={handleInputChange}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  size="small"
                                  required
                                  disabled={!!id}
                                />
                              </Col>
                              <Col lg={4} md={12} xs={12} className="mb-4">
                                <InputField
                                  label="Pozicija proizvoda"
                                  name="position"
                                  value={data?.position}
                                  onChange={handleInputChange}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  size="small"
                                />
                              </Col>

                              <Col lg={4} md={12} xs={12} className="mb-3">
                                <FormControl fullWidth size="small" required>
                                  <InputLabel id="demo-simple-select-label">
                                    Tip proizvoda
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={data?.type}
                                    label="Tip proizvoda"
                                    name="type"
                                    onChange={handleInputChange}
                                    size="small"
                                    disabled={!!id}
                                  >
                                    <MenuItem value="COFFEE">Kafa</MenuItem>
                                    <MenuItem value="EQUIPMENT">
                                      Dodatna oprema
                                    </MenuItem>
                                    <MenuItem value="CLOTHS">Odeća</MenuItem>
                                  </Select>
                                </FormControl>
                              </Col>
                            </Row>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col lg={12}>
                      <Card>
                        <Card.Header>
                          <FormTitleMain title="Prevodi" />
                        </Card.Header>
                        <Card.Body>
                          {/* Tabs header */}
                          <Tabs
                            value={activeLocaleTab}
                            onChange={handleChangeLocaleTab}
                            variant="scrollable"
                            // scrollButtons
                            // allowScrollButtonsMobile
                          >
                            {languagesItems.map((lng, idx) => (
                              <Tab
                                key={lng.code}
                                label={lng.label}
                                {...a11yProps(idx)}
                                // primer: pokaži zvezdicu ako fali naslov
                                iconPosition="end"
                              />
                            ))}
                          </Tabs>

                          {/* Tabs content */}
                          {languagesItems.map((lng, idx) => (
                            <TabPanel
                              key={lng.code}
                              value={activeLocaleTab}
                              index={idx}
                            >
                              <Row>
                                <Col lg={12} className="mb-3">
                                  <InputField
                                    name={`name_${lng.code}`}
                                    label={`${t(`${translateForm}.title`)} `}
                                    value={locales[lng.code].name}
                                    size="small"
                                    onChange={(e) =>
                                      updateLocale(
                                        lng.code,
                                        "name",
                                        e.target.value
                                      )
                                    }
                                    error={errors?.locales?.[lng.code]?.name}
                                    errorsHandler={setErrors}
                                    required
                                  />
                                </Col>
                                <Col lg={12} className="mb-3">
                                  <label className="form-label">
                                    Kratak opis
                                    <span className="text-danger"> *</span>
                                  </label>
                                  <CKEditor
                                    editor={Editor}
                                    data={
                                      locales[lng.code].shortDescription || ""
                                    }
                                    onChange={(event, editor) => {
                                      const data = editor.getData();
                                      updateLocale(
                                        lng.code,
                                        "shortDescription",
                                        data
                                      );
                                    }}
                                    onReady={(editor) => {
                                      // opciono ako želiš da editor bude full width
                                      editor.editing.view.change((writer) => {
                                        writer.setStyle(
                                          "height",
                                          "150px",
                                          editor.editing.view.document.getRoot()
                                        );
                                      });
                                    }}
                                  />
                                  {errors?.locales?.[lng.code]
                                    ?.shortDescription && (
                                    <div className="text-danger mt-1">
                                      {
                                        errors.locales[lng.code]
                                          .shortDescription
                                      }
                                    </div>
                                  )}
                                </Col>
                                <Col lg={12} className="mb-3">
                                  <label className="form-label">
                                    Opis
                                    <span className="text-danger"> *</span>
                                  </label>
                                  <CKEditor
                                    editor={Editor}
                                    data={locales[lng.code].description || ""}
                                    onChange={(event, editor) => {
                                      const data = editor.getData();
                                      updateLocale(
                                        lng.code,
                                        "description",
                                        data
                                      );
                                    }}
                                    onReady={(editor) => {
                                      // opciono ako želiš da editor bude full width
                                      editor.editing.view.change((writer) => {
                                        writer.setStyle(
                                          "min-height",
                                          "250px",
                                          editor.editing.view.document.getRoot()
                                        );
                                      });
                                    }}
                                  />
                                  {errors?.locales?.[lng.code]?.description && (
                                    <div className="text-danger mt-1">
                                      {errors.locales[lng.code].description}
                                    </div>
                                  )}
                                </Col>
                              </Row>
                            </TabPanel>
                          ))}
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Col>
                <Col lg={4}>
                  <Row>
                    <Col lg={12}>
                      <Card>
                        <Card.Header>{t(`global.settings`)}</Card.Header>
                        <Card.Body>
                          <SelectStatus
                            active={true}
                            data={data}
                            handleInputChange={handleInputChange}
                          />
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col lg={12}>
                      <Card>
                        <Card.Header>{t(`global.settings`)}</Card.Header>
                        <Card.Body>
                          <FormControl fullWidth>
                            <FormGroup row={true}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    size="small"
                                    name="filtered"
                                    checked={!!data?.filtered}
                                    onChange={handleInputChange}
                                    disabled={data?.type !== "COFFEE"} // opcionalno: samo za kafu
                                  />
                                }
                                label={"Nivo mlevenja"}
                              />

                              <FormControlLabel
                                control={
                                  <Checkbox
                                    size="small"
                                    name="espresso"
                                    checked={!!data?.espresso}
                                    onChange={handleInputChange}
                                    disabled={data?.type !== "COFFEE"} // opcionalno
                                  />
                                }
                                label={"Prženje"}
                              />
                            </FormGroup>
                          </FormControl>
                        </Card.Body>
                      </Card>
                    </Col>

                    <Col lg={12}>
                      <Card>
                        <Card.Header>Slika</Card.Header>
                        <Card.Body>
                          <div className="image-info-detail">
                            <span>
                              <b>Dimenzija slike:</b> 240 x 315 px
                            </span>
                            <br />
                            <span>
                              <b>Format slike:</b> .jpg, .png, .jpeg, .gif,
                              .svg, .webp
                            </span>
                            <br />
                            <span>
                              <b>Veličina fajla:</b> 500 KB (preporučeno)
                            </span>
                          </div>
                          <Button
                            variant="contained"
                            size="small"
                            startIcon={<FileUploadIcon />}
                            onClick={() => setShowMediaModal(true)}
                            className="default-btn-primary w-100 mb-1"
                          >
                            Izaberi sliku
                          </Button>

                          {(files.image || data?.imageFile) && (
                            <img
                              src={files.image || data?.imageFile}
                              alt={data?.imageName || ""}
                              style={{ width: "100%", marginTop: 10 }}
                            />
                          )}

                          {errors?.image && (
                            <div
                              style={{
                                marginTop: 8,
                                color: "#d32f2f",
                                fontSize: 12,
                              }}
                            >
                              {errors.image}
                            </div>
                          )}

                          <MediaPickerModal
                            show={showMediaModal}
                            onClose={() => setShowMediaModal(false)}
                            onSelect={handleImageSelect}
                          />
                        </Card.Body>
                      </Card>
                    </Col>

                    <Col lg={12}>
                      <Card>
                        <Card.Header>Dodatne slike (galerija)</Card.Header>
                        <Card.Body>
                          <Button
                            variant="contained"
                            size="small"
                            startIcon={<FileUploadIcon />}
                            onClick={() => setShowGalleryModal(true)}
                            className="default-btn-primary w-100 mb-2"
                          >
                            Dodaj sliku u galeriju
                          </Button>

                          {!!(data.imageGallery || []).length && (
                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(3, 1fr)",
                                gap: 8,
                              }}
                            >
                              {(data.imageGallery || []).map((img) => (
                                <div
                                  key={img.id}
                                  style={{ position: "relative" }}
                                >
                                  <img
                                    src={img.file}
                                    alt={img.name || ""}
                                    style={{
                                      width: "100%",
                                      height: 90,
                                      objectFit: "cover",
                                      borderRadius: 8,
                                      border: "1px solid #e5e7eb",
                                    }}
                                  />
                                  <button
                                    type="button"
                                    onClick={() => removeFromGallery(img.id)}
                                    style={{
                                      position: "absolute",
                                      top: 6,
                                      right: 6,
                                      width: 24,
                                      height: 24,
                                      borderRadius: 999,
                                      border: "none",
                                      background: "rgba(255,255,255,0.9)",
                                      cursor: "pointer",
                                      display: "grid",
                                      placeItems: "center",
                                    }}
                                  >
                                    ✕
                                  </button>
                                </div>
                              ))}
                            </div>
                          )}

                          <MediaPickerModal
                            show={showGalleryModal}
                            onClose={() => setShowGalleryModal(false)}
                            onSelect={(media) => {
                              handleGallerySelect(media);
                              setShowGalleryModal(false);
                            }}
                            multiple={true}
                          />
                        </Card.Body>
                      </Card>
                    </Col>

                    <Col lg={12}>
                      <Card>
                        <Card.Header>Veličina pakovanja</Card.Header>
                        <Card.Body>
                          {errors?.detailsGeneral && (
                            <div
                              style={{
                                marginBottom: 10,
                                color: "#d32f2f",
                                fontSize: 12,
                              }}
                            >
                              {errors.detailsGeneral}
                            </div>
                          )}
                          {(PRODUCT_TYPE_CONFIG[data.type] || []).map(
                            ({ value, label }) => {
                              const row =
                                data.details?.find((d) => d.size === value) ||
                                makeDetailRow(value);

                              return (
                                <Row
                                  key={value}
                                  className="align-items-center mb-3 product-size-container-item"
                                >
                                  <Col xs={3}>
                                    <label
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 8,
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        checked={!!row.active}
                                        onChange={(e) =>
                                          updateDetail(
                                            value,
                                            "active",
                                            e.target.checked
                                          )
                                        }
                                        disabled={data.type === "EQUIPMENT"} // ako hoćeš da DEFAULT uvek bude aktivan
                                      />
                                      {label}
                                    </label>
                                  </Col>

                                  <Col xs={5}>
                                    <AmountInputField
                                      label="Cena"
                                      name={`price_${value}`}
                                      value={row.price}
                                      onChange={(e) =>
                                        updateDetail(
                                          value,
                                          "price",
                                          e.target.value
                                        )
                                      }
                                      size="small"
                                      fullWidth
                                      required={row.active}
                                      disabled={!row.active}
                                      inputProps={{
                                        endAdornment: (
                                          <InputAdornment position="start">
                                            RSD
                                          </InputAdornment>
                                        ),
                                      }}
                                    />
                                  </Col>

                                  <Col xs={4}>
                                    <InputField
                                      label="Količina"
                                      name={`quantity_${value}`}
                                      value={row.quantity}
                                      onChange={(e) =>
                                        updateDetail(
                                          value,
                                          "quantity",
                                          e.target.value
                                        )
                                      }
                                      size="small"
                                      fullWidth
                                      disabled={!row.active}
                                      required={
                                        (row.active &&
                                          data.type === "CLOTHS") ||
                                        data.type === "EQUIPMENT"
                                      } // ✅ ovo dodaj
                                    />
                                  </Col>

                                  {/* Popust toggle */}
                                  <Col xs={3} className="mt-3">
                                    <label
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 8,
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        checked={!!row.discount}
                                        onChange={(e) =>
                                          updateDetail(
                                            value,
                                            "discount",
                                            e.target.checked
                                          )
                                        }
                                        disabled={!row.active}
                                      />
                                      Popust
                                    </label>
                                  </Col>

                                  <Col xs={9} className="mt-3">
                                    <AmountInputField
                                      label="Cena sa popustom"
                                      name={`discountPrice_${value}`}
                                      value={row.discountPrice}
                                      onChange={(e) =>
                                        updateDetail(
                                          value,
                                          "discountPrice",
                                          e.target.value
                                        )
                                      }
                                      size="small"
                                      fullWidth
                                      disabled={!row.active || !row.discount}
                                      required={row.active && row.discount}
                                      error={{
                                        [`discountPrice_${value}`]:
                                          errors?.details?.[value]
                                            ?.discountPrice,
                                      }}
                                      inputProps={{
                                        endAdornment: (
                                          <InputAdornment position="start">
                                            RSD
                                          </InputAdornment>
                                        ),
                                      }}
                                    />
                                  </Col>
                                  <Col xs={6} className="mt-3">
                                    <InputField
                                      label="Popust od"
                                      type="date"
                                      name={`discountStart_${value}`}
                                      value={row.discountStart}
                                      inputLabelProps={{ shrink: true }}
                                      error={
                                        !!errors?.details?.[value]
                                          ?.discountStart
                                      }
                                      helperText={
                                        errors?.details?.[value]?.discountStart
                                      }
                                      onChange={(e) =>
                                        updateDetail(
                                          value,
                                          "discountStart",
                                          e.target.value
                                        )
                                      }
                                      size="small"
                                      fullWidth
                                      disabled={!row.active || !row.discount}
                                      required={row.active && row.discount}
                                    />
                                  </Col>

                                  <Col xs={6} className="mt-3">
                                    <InputField
                                      label="Popust do"
                                      type="date"
                                      name={`discountEnd_${value}`}
                                      value={row.discountEnd}
                                      inputLabelProps={{ shrink: true }}
                                      error={
                                        !!errors?.details?.[value]?.discountEnd
                                      }
                                      helperText={
                                        errors?.details?.[value]?.discountEnd
                                      }
                                      onChange={(e) =>
                                        updateDetail(
                                          value,
                                          "discountEnd",
                                          e.target.value
                                        )
                                      }
                                      size="small"
                                      fullWidth
                                      disabled={!row.active || !row.discount}
                                      required={row.active && row.discount}
                                    />
                                  </Col>
                                </Row>
                              );
                            }
                          )}
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </form>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default ProductAdd;
